import { useMediaQuery } from "@nexxt/ui";

/** The visitor asked for less movement: scenes stand at their last step and scrolling moves nothing (ADR-286). */
export const useStill = () => useMediaQuery("(prefers-reduced-motion: reduce)");

/** The page follows the system's scheme, and so do the windows of the scenes (`.dark` with their `data-product`). */
export const useDark = () => useMediaQuery("(prefers-color-scheme: dark)");
